export const ITEM_CLICK = 'itemClick';


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/clip-list/events.js
 **/